<div class="form-floating">
  @if (!isEditing()) {
    <input
      type="text"
      class="form-control"
      readonly
      tabindex="0"
      id="salaryPreview"
      [value]="formattedPreviewText()"
      [placeholder]="placeholder"
      (focus)="onPreviewFocus()"
      />
  } @else {
    <input
      #salaryNumberInput
      id="salaryAmount"
      type="text"
      class="form-control"
      autocomplete="off"
      inputmode="numeric"
      [placeholder]="placeholder"
      [formControl]="control"
      (blur)="onNumberBlur()"
      (keydown)="onSalaryKeydown($event)"
      (paste)="onSalaryPaste($event)"
      />
  }
  <label [attr.for]="isEditing() ? 'salaryAmount' : 'salaryPreview'">{{ placeholder }}</label>
</div>
